import React from 'react';
import SIcon from './SIcon';
import { faThermometerHalf } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faThermometerHalf} fa />;

export default Icon;
